/* eslint-disable @typescript-eslint/no-var-requires */
import auPopularCategories from './AU.json';
import nzPopularCategories from './NZ.json';
import usPopularCategories from './US.json';
import sgPopularCategories from './SG.json';
import caPopularCategories from './CA.json';
import ukPopularCategories from './UK.json';
import frPopularCategories from './FR.json';
import dePopularCategories from './DE.json';
import esPopularCategories from './ES.json';
import itPopularCategories from './IT.json';
import sePopularCategories from './SE.json';
import iePopularCategories from './IE.json';
import nlPopularCategories from './NL.json';
import atPopularCategories from './AT.json';
import bePopularCategories from './BE.json';
import ptPopularCategories from './PT.json';
import fiPopularCategories from './FI.json';
import { PopularCategory } from './types';

let popularCategories = auPopularCategories;

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-au') {
  popularCategories = auPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-nz') {
  popularCategories = nzPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-dev') {
  popularCategories = auPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-us') {
  popularCategories = usPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-ca') {
  popularCategories = caPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-uk') {
  popularCategories = ukPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-fr') {
  popularCategories = frPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-de') {
  popularCategories = dePopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-es') {
  popularCategories = esPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-it') {
  popularCategories = itPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-se') {
  popularCategories = sePopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-ie') {
  popularCategories = iePopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-nl') {
  popularCategories = nlPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-at') {
  popularCategories = atPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-be') {
  popularCategories = bePopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-pt') {
  popularCategories = ptPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-fi') {
  popularCategories = fiPopularCategories;
}

if (process.env.NEXT_PUBLIC_STORE === 'quista') {
  popularCategories = sgPopularCategories;
}

export default popularCategories as PopularCategory[];
